import store from "../../store";
import { rollbar } from "../../rollbar";
import { createApiClient } from "@estaly/ui";

export const ApiUrl = process.env.VUE_APP_API_BASE_URL;

export const { plainAxiosInstance } = createApiClient({
  apiUrl: ApiUrl,
  getStore: () => store,
  rollbar,
  withCredentials: false,
});
